import React, {useCallback, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "../components/common/PageContainer";

import landing from "../assets/images/illustrations/landing.jpg";
import Button from "react-bootstrap/Button";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export default function Login() {
    const { instance } = useMsal();
    const navigate = useNavigate();

    
    const REDIRECT_PAGE = "/mails"; // Path to redirect after login | CAN BE CHANGED

    /**
     * Handles the login button click event
     * it will trigger the loginPopup method from the MSAL instance
     */
    const handleLogin = useCallback(async () => {
        try {
            await instance.loginRedirect({
                scopes: ["User.Read"] 
            });
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                instance.loginRedirect({ scopes: ["User.Read"] });
            } else {
                console.error(error);
            }
        }
    }, [instance]);


    useEffect(() => {

        if(instance.getActiveAccount() !== null) {
            navigate(REDIRECT_PAGE);
            return;
        }

        const account = instance.getAllAccounts()[0];
        if (account) {
            instance.setActiveAccount(account);
            navigate(REDIRECT_PAGE);
        }
        
    }, [instance, navigate]);
    

    return (
        <PageContainer>
            <section className="slice landing fullscreen">
                <div className="slice-wrapper">
                    <header className="slice-header">
                        <h1>AutoMail</h1>
                    </header>
                    <div className="slice-content">
                        <div className="landing-illustration">
                            <img src={landing} alt="AutoMail" title="AutoMail"></img>
                        </div>
                        <div className="landing-content">
                        <section className="form">
                            <Button type="button" variant="btn btn-primary btn-signin" 
                                    title="Se connecter"
                                    onClick={handleLogin} >
                                <span className="icon"></span>
                                <span className="text">Se connecter</span>
                            </Button>
                        </section>
                        </div>
                    </div>
                </div>
            </section>
        </PageContainer>
    )
}